import * as yup from 'yup';

import { FORM_FIELDS } from '@constants/form';

export const CREATE_NEW_LOAN = FORM_FIELDS.PROVIDENT_FUND.CREATE_NEW_LOAN;

export const addNewLoanValidation = yup.object().shape({
  [CREATE_NEW_LOAN.LOAN_ID]: yup.string().required('Loan ID is required'),
  [CREATE_NEW_LOAN.LOAN_AMOUNT]: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .required('Loan amount is required')
    .typeError('Loan amount has to be a number'),
  [CREATE_NEW_LOAN.LOAN_ISSUE_DATE]: yup
    .string()
    .required('Loan issue date is required'),
  [CREATE_NEW_LOAN.LOAN_APPLICATION]: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
  [CREATE_NEW_LOAN.DOCUMENT]: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
});

export type AddNewLoanFormDataType = yup.InferType<typeof addNewLoanValidation>;
